import semver from "semver";
import domtoimage from 'dom-to-image';
import uuidv1 from 'uuid/v1';
import lzbase62 from "lzbase62";

export function canUseDOM() {
  return !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
  );
}

export function isProductionEnvironment() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return true if production
  if (is.equal(process.env.NODE_ENV, "production")) {
    return true;
  }

  // Return false
  return false;
}

export function isIframeEnvironment() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return false if desktop and unreleased version
  if (canUseDOM && window.location !== window.parent.location) {
    return true;
  }

  // Return false
  return false;
}

export function isDesktopApp() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return false if desktop and unreleased version
  if (is.equal(queryParameters.platform, "desktop")) {
    return true;
  }

  // Return false
  return false;
}

export function isReleased() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Set if is released or not
  const isReleased = false;
  //
  // // Return false if unreleased
  // if (
  //   is.equal(queryParameters.platform, "desktop") &&
  //   is.existy(queryParameters.version) &&
  //   semver.eq(queryParameters.version, "1.0.8") &&
  //   is.falsy(isReleased)
  // ) {
    return false;
  // }

  // Return true
  return true;
}

export function isEmbedApp() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return false if desktop and unreleased version
  if (global.queryParameters.platform == "embed") {
    return true;
  }

  // Return false
  return false;
}

export function isGamedistributionApp() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return false if desktop and unreleased version
  if (global.queryParameters.platform == "gamedistribution") {
    return true;
  }

  // Return false
  return false;
}

export function getParams(query) {
  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split("&")
    .reduce((params, param) => {
      const [key, value] = param.split("=");
      return Object.assign(params, {
        [key]: value ? decodeURIComponent(value.replace(/\+/g, " ")) : ""
      });
    }, {});
}

export function mailTo() {
  $.notify("Opening email... hang on.");

  const openEmail = (imageURL) => {
    const body = `
      %0D%0A
      %0D%0A
      ------
      %0D%0A%0D%0A
      When%20reporting%20a%20bug,%20please%20describe%20the%20bug%20as%20clearly%20as%20possible.
      %0D%0A%0D%0A
      Game:%20${global.game}
      %0D%0A%0D%0A
      Platform:%20${window.queryParameters.platform}
      %0D%0A%0D%0A
      Version:%20${window.queryParameters.version}
      %0D%0A%0D%0A
      ID:%20${firebase.auth().currentUser.uid}
      %0D%0A%0D%0A
      Screenshot:%20${imageURL}
      %0D%0A%0D%0A
      Device:%20${global.bowser.osname}%20${global.bowser.osversion}
      %0D%0A%0D%0A
      Browser:%20${global.bowser.name}%20${global.bowser.version}
    `;

    window.location.href = `mailto:contact@online-jigsaw-puzzles.com?subject=Jigsaw%20Puzzle%20feedback%20(${global.game})&body=${body}`

    Raven.captureMessage('Email has been opened', {
      level: 'error',
      tags: {
        game: global.game,
        uid: firebase.auth().currentUser.uid
      }
    });
  }

  if (canUseDOM()) {
    domtoimage.toJpeg(document.getElementById('game_container'), {
      quality: 0.50,
      bgcolor: "#EBEBEB",
      filter: (node) => is.not.equal(node.id, "p_2104993")
    }).then((dataUrl) => {
      firebase.storage().ref().child(`screenshots/${global.game}_${uuidv1()}.jpg`).putString(dataUrl, 'data_url').then((snapshot) => {
        snapshot.ref.getDownloadURL().then((downloadURL) => {
          openEmail(encodeURIComponent(downloadURL))
        });
      }).catch((error) => {
        openEmail("Not available")
      });;
    }).catch((error) => {
      openEmail("Not available")
    });
  }
}

let sentryMessageSent = false;
export function sentryTrackAction(action) {
  Raven.captureBreadcrumb({
    message: action,
    category: 'action'
  });
}



// WEBPACK FOOTER //
// ./src/utils/misc.js